import { render } from "./App.vue?vue&type=template&id=09025ed5"
const script = {}

import exportComponent from "/Users/gx/Projects/echarge/evs-fe/recharge-agreement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__